module.exports = __webpack_public_path__ + "static/media/kick-that-habit-man.886b612c.txt";